module.exports = __webpack_public_path__ + "img/de50a99vidas.83a84dcd.png";